// extracted by mini-css-extract-plugin
export default {"pleaseVerifyContainer":"pleaseVerify_pleaseVerifyContainer__ZlGux","pleaseVerify":"pleaseVerify_pleaseVerify__d3EWA"};